import * as React from "react";
const PrivateSteppingContext = React.createContext(null);
const usePrivateSteppingContext = () => {
  const context = React.useContext(PrivateSteppingContext);
  if (context === null) {
    throw Error(
      `Consumer of useSteppingContext needs to be wrapped in a PrivateSteppingContext provider.`
    );
  }
  return context;
};
const PrivateSteppingContextProvider = ({
  children,
  configuratorId,
  stepsMap,
  stepSequence,
  lastStepCTALabelKey,
  footerTopBarContent,
  footerExpanderContent,
  hideExpanderOnLastStep
}) => {
  const id = configuratorId;
  const selectorProps = React.useMemo(
    () => ({ id, stepsMap, stepSequence }),
    [id, stepsMap, stepSequence]
  );
  const context = React.useMemo(
    () => ({
      selectorProps,
      configuratorId,
      stepsMap,
      lastStepCTALabelKey,
      footerExpanderContent,
      footerTopBarContent,
      hideExpanderOnLastStep
    }),
    [
      selectorProps,
      configuratorId,
      stepsMap,
      lastStepCTALabelKey,
      footerExpanderContent,
      footerTopBarContent,
      hideExpanderOnLastStep
    ]
  );
  return /* @__PURE__ */ React.createElement(PrivateSteppingContext.Provider, { value: context }, children);
};
export {
  PrivateSteppingContext,
  PrivateSteppingContextProvider,
  usePrivateSteppingContext
};
//# sourceMappingURL=PrivateSteppingContext.js.map
